/**
 * Layer-3 seam for a BESPOKE, design-faithful landing page.
 *
 * Baseline: no bespoke landing — the front door (`/`) is composed from the
 * section registry per `layout` (storefront-first or a section-composed landing).
 *
 * A tenant whose landing must match a specific handoff 1:1 (e.g. a corporate site
 * recreation) ships its own `src/tenants/<id>/storefront/tenant-landing.tsx` that
 * sets `HAS_BESPOKE_LANDING = true` and renders the hand-built page. Resolved at
 * build time via the `@app/*` alias (TENANT=<id>). This is the *blessed* folder
 * use — a landing carries no business logic, so it can't drift against core.
 */
export const HAS_BESPOKE_LANDING = false;

export function TenantLanding(): JSX.Element | null {
  return null;
}

/**
 * Bespoke renderer for NON-home layout pages (e.g. a tenant's own /gallery,
 * /about-us, /contact). Baseline returns null so those paths stay section-driven;
 * a tenant override (TENANT=<id>) returns its hand-built page for known paths.
 * Consumed by `home.tsx` for any layout page whose path isn't the homePath.
 */
export function renderTenantPage(_path: string): JSX.Element | null {
  return null;
}

/**
 * Extra storefront routes a bespoke tenant build mounts from CODE (independent
 * of the runtime `layout.pages`, so they work even against a stale/other stored
 * layout). App.tsx routes each through `StorefrontHome`, which delegates to
 * `renderTenantPage`. Baseline mounts nothing extra. Paths must be non-reserved.
 */
export const TENANT_ROUTES: string[] = [];
